// /sims — Sims Brothers Recycling · Fleet Logistics
// Thin wrapper on the shared VerticalCockpit chassis.
// Skin: industrial navy + safety orange.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function SimsCommand() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.LOGISTICS}
      palette={PALETTES.LOGISTICS}
      testPrefix="sm"
    />
  );
}
